import { Card } from "@/components/ui/card";
import { Listing, City } from "@/lib/types";
import { MapPin, Building2 } from "lucide-react";
import { useCities } from "@/hooks/useCities";

interface LocationDetailsSectionProps {
  property: Listing;
}

const LocationDetailsSection = ({ property }: LocationDetailsSectionProps) => {
  const { data: cities } = useCities();
  const city = cities?.find((c) => c.id === property.city_id);

  console.log("LocationDetailsSection - property.city_id:", property.city_id);
  console.log("LocationDetailsSection - cities data:", cities);
  console.log("LocationDetailsSection - found city:", city);

  const displayAddress = property.address || "Address not available";
  const displayCityName =
    city?.display_name || city?.name || "City not available";

  return (
    <Card className="p-5 border border-propertylk-blue/10">
      <h3 className="text-lg font-semibold text-propertylk-darkblue mb-4">
        Location Details
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-1 gap-y-4 gap-x-8 mb-6">
        {/* Address */}
        {property.address && (
          <div className="flex items-center gap-2">
            <MapPin className="h-5 w-5 text-gray-600" />
            <span className="text-gray-600">Address</span>
            <span className="font-medium ml-2">{displayAddress}</span>
          </div>
        )}

        {/* City */}
        {(city?.display_name || city?.name) && (
          <div className="flex items-center gap-2">
            <Building2 className="h-5 w-5 text-gray-600" />
            <span className="text-gray-600">City</span>
            <span className="font-medium ml-2">{displayCityName}</span>
          </div>
        )}
      </div>
    </Card>
  );
};

export default LocationDetailsSection;
